
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiFishing as ObiFishingElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-fishing.js';
 
 
 

 
 export const ObiFishing = createComponent({
   react: React,
   tagName: 'obi-fishing',
   elementClass: ObiFishingElement,
   events: {
     
   }
  });
 
 